module.exports = __webpack_public_path__ + "img/btn_camera_off.7ca8b9b1.png";